
import React from "react";
import { 
  StandardPageHeaderLoading,
  StandardCardLoading 
} from "@/components/ui/standard-loading";

const ClassDetailLoading: React.FC = () => {
  return (
    <div className="space-y-6">
      <StandardPageHeaderLoading 
        hasBackButton={true}
        hasSubtitle={true}
        hasActions={true}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <StandardCardLoading hasHeader={true} textLines={4} />
          <StandardCardLoading hasHeader={true} textLines={6} />
        </div>
        
        <div className="space-y-6">
          <StandardCardLoading hasHeader={true} textLines={3} />
          <StandardCardLoading hasHeader={false} textLines={5} />
        </div>
      </div>
    </div>
  );
};

export default ClassDetailLoading;
